module.exports = __webpack_public_path__ + "static/media/whatsapp-footer.41b13b0d.svg";